import { Joint } from "@components/Physics/Joint";
import * as THREE from "three";
import * as RAPIER from '@dimforge/rapier3d-compat'
import { SpecificController } from "@components/SpecificController";
import { OverlayInterface } from "@components/UI/OverlayInterface";
export class CarController extends SpecificController {
    localRotation = new THREE.Euler(-0.5, 1.5, 0)
    cameraDistance = 20
    get input() { return this.gameObject.engine.input }
    maxRotation = 1
    currentRotation = 0

    jointInitialised = false

    instructionOverlay!: OverlayInterface

    setup(_data: any) {
        super.setup(_data)

        this.localRotation = this.playerController.transform.transformData.clone().lookAt(this.transform.position).rotation

        console.log('added car controller')
    }
    start() {
        //TODO add overlay with instructions
        this.instructionOverlay = this.gameObject.addComponent(OverlayInterface, {
            innerHTML: `
            <div style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5);padding: 10px; border: none; border-radius: 10px;">
                <span style = "color: white; font-family: Arial, sans-serif; font-size: 24px;">Utilisez ZQSD pour se deplacer <br>La souris + click gauche pour tourner la camera <br>Espace pour freiner ou reculer <br>ESC pour quitter</span>
            </div>
        `})

    }
    updateActions(_dt: number): void {
        if (this.engine.input.onPress('Escape')) {
            this.remove()
        }
        //const camera = cameraGo.getComponent(PlayerController)!


        // rotation system
        const mouseMove = (new THREE.Vector2(this.input.mouse.movementX, - this.input.mouse.movementY)).multiplyScalar(0.01)
        if (this.input.mouse.leftClick) {
            //stuck mouse cursor
            this.engine.canvas!.requestPointerLock();


            this.localRotation = new THREE.Euler(this.localRotation.x + mouseMove.y, this.localRotation.y - mouseMove.x, this.localRotation.z, 'ZYX')
            // clamp rotation
            if (this.localRotation.x > Math.PI / 2) this.localRotation.x = Math.PI / 2
            if (this.localRotation.x < -Math.PI / 2) this.localRotation.x = -Math.PI / 2

        }
        else {
            document.exitPointerLock();
        }
        const rotationInput = this.input.getAxis(['KeyA', 'ArrowLeft'], ['KeyD', 'ArrowRight']) * this.maxRotation
        this.currentRotation = THREE.MathUtils.lerp(this.currentRotation, rotationInput, 0.01)
        this.currentRotation = THREE.MathUtils.clamp(this.currentRotation, -this.maxRotation, this.maxRotation)
        const wheels = this.gameObject.children.filter(c => c.hasTag('damper'))
        for (const damper of wheels) {
            const damperSpring = (damper.userData.springJoint as Joint).joint as RAPIER.SpringImpulseJoint
            if (damperSpring) {
                const wheel = damper.children[0]

                //damperSpring.setAnchor1(new THREE.Vector3(0, rotationInput * (wheel.userData.wheelId % 2 == 0 ? 1 : -1), 0).add(((damper.userData.springJoint as Joint).buildData.params as RAPIER.JointData).anchor1))



                const controler = wheel.getComponent(Joint)?.joint as RAPIER.RevoluteImpulseJoint
                if (controler) {
                    if (!this.jointInitialised) {

                        controler.setLimits(this.currentRotation, this.currentRotation)
                    }

                    const targetedRotation = this.currentRotation * (wheel.userData.wheelId < 2 ? 0 : 1)
                    controler.setLimits(targetedRotation, targetedRotation)
                    //controler.configureMotorModel(RAPIER.MotorModel.ForceBased);
                    //controler.configureMotorVelocity(rotationInput * 100, 1)

                    const motor = wheel.children[0].getComponent(Joint)?.joint as RAPIER.RevoluteImpulseJoint
                    if (motor) {
                        motor.configureMotorModel(RAPIER.MotorModel.ForceBased);
                        motor.configureMotorVelocity(this.input.getAxis(['KeyW', 'ArrowUp'], ['KeyS', 'ArrowDown', 'Space']) * 100 * (wheel.userData.wheelId < 2 ? Math.cos(this.currentRotation) : 1), 1)
                    }
                }
            }
        }
        this.jointInitialised = true
    }
    update(_dt: number) {

    }
    onMove() {
        const targetTransform = this.transform.transformData.clone()
        targetTransform.rotation = this.localRotation
        this.targetTransform = targetTransform
        this.cameraDistance = this.cameraDistance
    }
    onDestroy() {
        console.log('removed car controller')
        this.playerController.setDistanceSavingCameraPosition(0)
        this.instructionOverlay.remove()
        super.onDestroy()
    }
}
